/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/toggle/custom-elements';

import { defineCustomElement as defineOsdsToggle } from '@ovhcloud/ods-stencil/components/toggle/custom-elements/osds-toggle.js';


export const OsdsToggle = /*@__PURE__*/ defineContainer<JSX.OsdsToggle>('osds-toggle', defineOsdsToggle, [
  'contrasted',
  'checked',
  'checking',
  'color',
  'disabled',
  'interactive'
]);

